import type { IBlotterBookableQuote } from 'models/IBlotterExoPricingQuote';
import type { IBlotterQuoteItem } from 'models/IBlotterItem';
import { connect } from 'react-redux';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { addToOrdersBasket } from 'state/orders-basket/actions';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

type AddToOrderBasketButtonOwnProps = {
  data: IBlotterQuoteItem;
};

type AddToOrderBasketButtonStateProps = {};

type AddToOrderBasketButtonDispatchProps = {
  onAdd: (data: IBlotterQuoteItem, tabName: string) => void;
};

export type AddToOrderBasketButtonProps = AddToOrderBasketButtonOwnProps &
  AddToOrderBasketButtonStateProps &
  AddToOrderBasketButtonDispatchProps;

const mapStateToProps = (_: AppState): AddToOrderBasketButtonStateProps => {
  return {};
};

const mapDispatchToProps = (dispatch: ThunkDispatch): AddToOrderBasketButtonDispatchProps => ({
  onAdd: (data: IBlotterQuoteItem, tabName: string) => {
    logAnalytics.trackEvent('Orders Basket', 'Add an item to Order Basket', data.productCode);
    const quote: IBlotterBookableQuote = data as IBlotterBookableQuote;
    dispatch(
      addToOrdersBasket(
        quote.quoteId,
        quote.wrapper,
        quote.productType,
        quote.productSubType,
        tabName,
        quote.processingChain,
        quote.pricerRfqId,
        quote.productId,
      ),
    );
  },
});

export const connectAddToOrderBasketButton = connect(mapStateToProps, mapDispatchToProps);
